import styled from '@emotion/styled';
import { Text } from 'components';

export const TabTitle = styled(Text)`
  display: block;
  font-size: 24px;
  font-weight: 600;
`;
